/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Queues_Wrap_Up_Time_SecondsInputs */

const en_tables_queues_wrap_up_time_seconds = /** @type {(inputs: Tables_Queues_Wrap_Up_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrap Up Time Seconds`)
};

const de_tables_queues_wrap_up_time_seconds = /** @type {(inputs: Tables_Queues_Wrap_Up_Time_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachbearbeitungszeit in Sekunden`)
};

/**
* | output |
* | --- |
* | "Wrap Up Time Seconds" |
*
* @param {Tables_Queues_Wrap_Up_Time_SecondsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_queues_wrap_up_time_seconds = /** @type {((inputs?: Tables_Queues_Wrap_Up_Time_SecondsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Queues_Wrap_Up_Time_SecondsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_queues_wrap_up_time_seconds(inputs)
	return de_tables_queues_wrap_up_time_seconds(inputs)
});